import React, {forwardRef} from 'react'

const Advertisement = forwardRef<HTMLDivElement, { src: string }>(({src}, ref) => {
    if (!src) {
      return null
    }

    return (
      <div ref={ref} className="logo-2-wrapper mb-3">
        <div className="logo-2-label">Advertisement</div>
        <img className="logo-2-img" alt="Logo 2" src={src} />
      </div>
    )
})

export default Advertisement;
